import { Button } from "@/components/ui/button";
import { Smartphone, FileUp } from "lucide-react";

/**
 * USBTroubleshooting - Collapsible troubleshooting tips for USB connection issues
 */
export function USBTroubleshooting() {
  return (
    <details className="mb-4 bg-[#0A0A0A] border border-white/[0.05] rounded-sm">
      <summary className="px-4 py-3 cursor-pointer text-sm text-[#71717A] hover:text-white flex items-center gap-2">
        <span className="text-[#FFCC00]">⚠️</span>
        ¿Problemas al conectar? Click para ver soluciones
      </summary>
      <div className="px-4 pb-4 space-y-3 text-sm">
        <div className="p-3 bg-[#FF3B30]/10 border border-[#FF3B30]/30 rounded">
          <p className="font-medium text-[#FF3B30] mb-1">Error: "Failed to open serial port"</p>
          <ul className="text-xs text-[#A1A1AA] space-y-1 ml-4 list-disc">
            <li><strong>Cierra otras aplicaciones</strong> que usen el tinySA (tinySA-App, terminal serial, etc.)</li>
            <li>Desconecta y vuelve a conectar el USB físicamente</li>
            <li>En Mac: Cierra completamente tinySA-App (Cmd+Q) antes de usar la web</li>
          </ul>
        </div>
        
        <div className="p-3 bg-[#FFCC00]/10 border border-[#FFCC00]/30 rounded">
          <p className="font-medium text-[#FFCC00] mb-1">El dispositivo no aparece</p>
          <ul className="text-xs text-[#A1A1AA] space-y-1 ml-4 list-disc">
            <li>Verifica que el cable USB soporta <strong>datos</strong> (no solo carga)</li>
            <li>Prueba otro puerto USB</li>
            <li>En Windows: Instala los drivers CH340 si es necesario</li>
          </ul>
        </div>
        
        <div className="p-3 bg-[#007AFF]/10 border border-[#007AFF]/30 rounded">
          <p className="font-medium text-[#007AFF] mb-1">Alternativas</p>
          <ul className="text-xs text-[#A1A1AA] space-y-1 ml-4 list-disc">
            <li><strong>Importar CSV:</strong> Escanea con tinySA-App y exporta el archivo</li>
            <li><strong>Visor Remoto:</strong> Conecta el tinySA a otra PC y visualiza desde cualquier dispositivo</li>
          </ul>
        </div>
      </div>
    </details>
  );
}

/**
 * MobileDeviceWarning - Banner shown when Web Serial is blocked (iPad/mobile)
 */
export function MobileDeviceWarning({ onOpenRemoteViewer, onOpenImport }) {
  return (
    <div className="p-5 bg-[#007AFF]/10 border-2 border-[#007AFF]/50 rounded-sm mb-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-[#007AFF]/20 flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-5 h-5 text-[#007AFF]" />
        </div>
        <div className="flex-1">
          <p className="text-base text-[#007AFF] font-bold mb-1">
            Modo iPad/Móvil Detectado
          </p>
          <p className="text-sm text-[#A1A1AA] mb-4">
            Los dispositivos móviles no pueden conectar USB directo. Usa el <strong>Visor Remoto</strong> para ver el espectro desde un tinySA conectado a otra computadora.
          </p>
          <div className="flex flex-wrap gap-3">
            <Button
              onClick={onOpenRemoteViewer}
              className="bg-[#007AFF] text-white hover:bg-[#007AFF]/90 font-bold"
              data-testid="open-remote-viewer-button"
            >
              <Smartphone className="w-4 h-4 mr-2" />
              Abrir Visor Remoto
            </Button>
            <Button
              onClick={onOpenImport}
              variant="outline"
              className="border-white/20 text-[#F4F4F5] hover:bg-white/5"
            >
              <FileUp className="w-4 h-4 mr-2" />
              Importar Archivo CSV
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default USBTroubleshooting;
